export default __webpack_public_path__ + "static/media/IslaDeLosValles.9814590e.jpg";